import styled from "@emotion/styled";
import { PageHeader } from "components/Common/Page";

export const ReplacementsHeaderWrapper = styled(PageHeader)(({ theme }) => ({
	backgroundColor: theme.project.colors.backgroundColors.main,
	padding: 24
}));
